import Reveal from '@/components/base/Reveal';
import { hotFeature, hotRanking } from '@/mocks/home';

export default function HotRankingSection() {
  return (
    <section id="hot" className="w-full bg-background-100 py-20 md:py-28">
      <div className="mx-auto max-w-[1400px] px-4 md:px-6">
        {/* 分区标题 */}
        <Reveal>
          <div className="flex flex-col gap-4 border-b border-background-300/70 pb-6 sm:flex-row sm:items-end sm:justify-between">
            <div>
              <div className="flex items-center gap-2 text-[12px] tracking-[0.28em] text-primary-600">
                <span className="h-px w-6 bg-primary-500" />
                01 / 热度榜
              </div>
              <h3 className="mt-3 font-heading text-[30px] font-black tracking-tight text-foreground-950 md:text-[40px]">
                今日热榜
              </h3>
              <p className="mt-2 max-w-[560px] text-[14px] leading-relaxed text-foreground-600">
                按阅读、转发与讨论热度综合排序，每小时刷新一次，前八名条目均可直接查看。
              </p>
            </div>
            <a
              href="#latest"
              className="flex shrink-0 cursor-pointer items-center gap-1.5 whitespace-nowrap text-[14px] font-medium text-primary-600 transition-colors hover:text-primary-700"
            >
              查看完整榜单
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-arrow-right-line text-[16px]" />
              </span>
            </a>
          </div>
        </Reveal>

        <div className="mt-10 grid grid-cols-1 gap-8 lg:grid-cols-[1.15fr_0.85fr] lg:gap-12">
          {/* 榜单列表 */}
          <div className="flex flex-col">
            {hotRanking.map((item, index) => (
              <Reveal key={item.rank} delay={index * 40}>
                <a
                  href="#latest"
                  className="group flex cursor-pointer items-center gap-4 border-b border-background-300/60 py-4 transition-colors hover:bg-background-50 md:gap-6 md:py-5"
                >
                  <span
                    className={`w-9 shrink-0 text-center font-heading text-[26px] font-black md:w-11 md:text-[32px] ${
                      item.rank <= 3 ? 'text-primary-500' : 'text-background-500'
                    }`}
                  >
                    {item.rank}
                  </span>
                  <div className="min-w-0 flex-1">
                    <h4 className="truncate text-[15px] font-medium text-foreground-900 transition-colors group-hover:text-primary-600 md:text-[16px]">
                      {item.title}
                    </h4>
                    <div className="mt-2 flex flex-wrap items-center gap-2 md:gap-3">
                      <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-[12px] text-secondary-900">
                        {item.tag}
                      </span>
                      <span className="flex items-center gap-1 text-[12px] text-foreground-500">
                        <span className="flex h-3.5 w-3.5 items-center justify-center">
                          <i className="ri-fire-line text-[13px]" />
                        </span>
                        {item.heat}
                      </span>
                    </div>
                  </div>
                  <span className="flex h-8 w-8 shrink-0 items-center justify-center text-background-500 transition-colors group-hover:text-primary-500">
                    <i className="ri-arrow-right-up-line text-[20px]" />
                  </span>
                </a>
              </Reveal>
            ))}
          </div>

          {/* 榜首封面卡 */}
          <Reveal delay={120}>
            <article className="sticky top-[124px] overflow-hidden rounded-lg border border-background-300/70 bg-background-50">
              <div className="relative h-[240px] w-full md:h-[300px]">
                <img
                  src={hotFeature.cover}
                  alt="今日热榜榜首爆料封面"
                  title="黑料免费 · 今日热榜榜首"
                  className="h-full w-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/20 to-transparent" />
                <span className="absolute left-4 top-4 rounded-full bg-primary-500 px-3 py-1 text-[12px] font-medium text-background-50">
                  {hotFeature.tag}
                </span>
                <div className="absolute bottom-4 left-4 right-4">
                  <div className="flex items-center gap-1.5 text-[12px] text-accent-400">
                    <span className="flex h-4 w-4 items-center justify-center">
                      <i className="ri-fire-fill text-[14px]" />
                    </span>
                    热度 {hotFeature.heat}
                  </div>
                </div>
              </div>
              <div className="p-5 md:p-6">
                <h4 className="font-heading text-[20px] font-bold leading-snug text-foreground-950 md:text-[23px]">
                  {hotFeature.title}
                </h4>
                <p className="mt-3 text-[14px] leading-relaxed text-foreground-600">
                  {hotFeature.summary}
                </p>
                <a
                  href="#latest"
                  className="mt-6 flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-primary-300 bg-primary-50 px-5 py-3 text-[14px] font-medium text-primary-700 transition-colors hover:bg-primary-100"
                >
                  查看完整条目
                  <span className="flex h-4 w-4 items-center justify-center">
                    <i className="ri-arrow-right-line text-[16px]" />
                  </span>
                </a>
              </div>
            </article>
          </Reveal>
        </div>
      </div>
    </section>
  );
}